import { FastlyImage } from '@components/common/image'
import CommonCarousel from '@components/common/carousel'

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1280 },
    items: 3,
    slidesToSlide: 3,
  },
  desktop: {
    breakpoint: { max: 1280, min: 768 },
    items: 2,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 768, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

export type Story = {
  image: string
  description: string
}

export const STORIES: Story[] = [
  {
    image: '/images/about-us/story/great-lakes.jpg',
    description:
      'Codingal’s free workshop at Great Lakes, Gurgaon—creating future coders! 🚀',
  },
  {
    image: '/images/about-us/story/vanya-bangladesh.jpg',
    description:
      'Vanya from Bangladesh visited our office coding knows no borders! 🌍💻',
  },
  {
    image: '/images/about-us/story/students-painted.jpg',
    description:
      'Two African students painted their Codingal instructor’s portrait and shipped it to India! 🎨✈️',
  },
  {
    image: '/images/about-us/story/student-determination.jpg',
    description:
      'After a tough accident, one student finished their project like a champ Codingal sparks determination! 💪💻',
  },
  {
    image: '/images/about-us/story/codingal-tshirt.jpg',
    description:
      'Meet our incredible young coding champions from Brihaspati Vidyasadan School, Nepal, rocking our adorable Codingal tee! 🐧',
  },
  {
    image: '/images/about-us/story/framed-certificate.jpg',
    description:
      'One student framed all their Codingal certificates—what a proud moment! 🏅📸',
  },
  {
    image: '/images/about-us/story/special-recognition-moment.jpg',
    description:
      'A special moment of recognition for our young Codingal learners! 🏆',
  },
  {
    image: '/images/about-us/story/ideas-turns-into-prototype.jpg',
    description:
      'Where ideas turned into prototypes at our offline Bangalore event! 🚀',
  },
  {
    image: '/images/about-us/story/parents-and-teachers.jpg',
    description: 'Parents, students, and proud Codingal memories! 💙',
  },
]

type StoriesProps = {
  story: Story
}

const StoriesCard = ({ story }: StoriesProps) => {
  return (
    <div className="relative">
      {/* <div className="mb-4 overflow-hidden"> */}
      <FastlyImage
        src={story.image}
        alt={story.description}
        width={377}
        height={504}
        className="w-full h-full object-cover"
      />
      <div className="absolute flex items-center bottom-0 p-2 h-24 text-base lg:text-lg leading-tight bg-white bg-opacity-75">
        <p>{story.description}</p>
      </div>
    </div>
  )
}

const Stories = ({ background }: { background?: string }) => {
  return (
    <div className="py-12 lg:py-16 px-5 container mx-auto">
      <div
        style={{ background }}
        className={`${
          background
            ? 'py-5 px-2 rounded-xl border border-orange-300 shadow-lg md:pb-20'
            : ''
        } relative`}
      >
        {/* Section heading */}
        {background && (
          <div className="absolute right-0 pr-3 hidden md:block">
            <FastlyImage
              src="/images/reviews-and-testimonials/sparkling.png"
              alt="Stars"
              height={85}
              width={85}
            />
          </div>
        )}
        <div className="text-center mb-8">
          <h2 className="max-w-4xl mx-auto pb-3 text-2xl text-center text-grey lg:text-4xl font-600">
            Stories that make us smile.
          </h2>
          <p className="text-lg text-grey">
            Helping children build confidence, curiosity and real skills
          </p>
        </div>

        {/* Carousel */}
        <CommonCarousel responsive={responsive}>
          {STORIES.map((story, index) => (
            <div key={index} className="px-2 h-full">
              <StoriesCard story={story} />
            </div>
          ))}
        </CommonCarousel>
        {background && (
          <div className="absolute -mt-5 pl-3 hidden md:block">
            <FastlyImage
              src="/images/reviews-and-testimonials/sparkling.png"
              alt="Stars"
              height={85}
              width={85}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Stories
